var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cell"},[_c('van-cell',{attrs:{"size":"large","title":_vm.title,"is-link":_vm.isShowArrow,"to":_vm.routerLinkTo,"value":_vm.arrowValue}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }